export interface SalesDespatchNoteStatusItem {
  id: string;
  salesDespatchNoteStatus: string;
  user: string;
  processedDate: Date;
}
